var $0e0388177f2c7eb2$exports = {};
$0e0388177f2c7eb2$exports = {
    "alert": `Alerte`,
    "dismiss": `Rejeter`
};


export {$0e0388177f2c7eb2$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
